<template>
  <v-app-bar
    :elevation="0"
    style="background-color: #2B2D33;"
    v-if="pageTitle !== '物控记录' && pageTitle !== '二级' && !pageTitle.includes('二级') && !route.meta.hideAppBar"
  >
    <v-btn
      v-if="showBackButton && pageTitle !== '合同信息'"
      icon
      variant="text"
      @click="handleBack"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <v-app-bar-title class="d-flex align-center">
      <span>{{ pageTitle }}</span>
      <span v-if="showOrderInfo" class="ml-4 text-subtitle-2">
        {{ orderInfo }}
      </span>
    </v-app-bar-title>

    <v-spacer />
    
    <template v-if="userStore.userInfo">
      <div class="d-flex align-center mr-4">
        <template v-for="(item, index) in menus" :key="index">
          <!-- 合同管理下拉菜单 -->
          <v-menu v-if="item.children && item.children.length > 0" location="bottom">
            <template v-slot:activator="{ props }">
              <!-- :class="['module-btn', { active: currentModule === item.parentTitle }]" -->
              <!-- :class="['module-btn', { active: currentModuleKind === item.title }]" -->
              <v-btn
                v-bind="props"
                variant="text"
                class="module-btn"
              >{{ item.title }}
                <span :class="{'active-text': currentModuleKind === item.title}"></span>
                <v-icon class="ml-1">mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list class="menu-list">
              <v-list-item
                v-for="(subItem, subIndex) in item.children"
                :key="subIndex"
                :to="subItem.path"
                @click="handleChange(item)"
                :class="{ active: navSubItemIsActive(subItem.path) }"
              >
                <!-- <v-list-item-title v-if="subItem.title === '集团报表'">
                  <a style="color: white;text-decoration: none;" target="_blank" href="./global.html">集团报表</a>
                </v-list-item-title> -->
                
                <v-list-item-title>
                  <!-- <v-img
                    v-if="subItem.icon && subItem.icon.startsWith('@/assets/')"
                    :src="subItem.icon.replace('@/assets/', 'assets/')"
                    width="20"
                    height="20"
                    style="flex: none !important;"
                    class="mr-1"
                  /> -->
                  <!-- <div v-else style="width:20px" class="mr-1"></div> -->
                  <!-- <v-icon v-else :icon="subItem.icon" class="mr-2" /> -->
                  
                  <v-icon v-if="subItem.icon" :icon="subItem.icon" class="mr-1" style="color:#fff;font-size: 18px;"/>
                  <template v-if="subItem.childTitle">
                    <div class="status-text" :class="subItem.childClass">{{subItem.childTitle}}</div>
                  </template>
                  <div style="text-align: center;display: flex;justify-content: center;flex:1">{{ subItem.title }}</div>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- 其他普通菜单项 -->
          <v-btn
            v-else
            :class="['module-btn', { active: currentModule === item.parentTitle }]"
            variant="text"
            @click="handleModuleChange(item)"
          >
            {{ item.title }}
          </v-btn>
        </template>
      </div>
      <div class="d-flex align-center">
        <!-- <div class="user-info mr-4">
          <v-avatar size="32" class="mr-2">
            <v-img src="src/assets/jf.png" alt="用户头像" />
          </v-avatar>
          <span class="nickname">{{ userStore.userInfo.nickname }}</span>
          <span class="dept-job ml-2">
            {{ userStore.userInfo.dept }} · {{ userStore.userInfo.job }}
          </span>
        </div> -->
        <!-- <v-btn
          prepend-icon="mdi-logout"
          @click="handleLogout"
          variant="text"
          class="logout-btn"
        >
          退出登录
        </v-btn> -->
        <div class="login-info" style="margin-right: 20px;">
          <div class="d-flex align-center">
            <div class="nickname">
              {{ userStore.userInfo.nickname }}
            </div>
            <v-btn style="height: auto;margin: 0px;min-width: auto;padding: 0px 10px;" prepend-icon="mdi-logout"  @click="handleLogout" variant="text" class="logout-btn"></v-btn>
          </div>
          <div class="dept-job">
            <!-- {{ userStore.userInfo.dept }} ·  -->
            {{ userStore.userInfo.job }}
          </div>
        </div>
      </div>
    </template>
  </v-app-bar>
</template>

<script setup lang="ts">
import { computed, ref, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { orderApi, authApi } from '@/services/api'
import { useOrderStore } from '@/stores/order'
import { getNavMenus } from '@/router'
import { clearVersionCache } from '@/utils/versionUtils'

const props = defineProps<{
  title?: string
  showBack?: boolean
  onBack?: () => void
}>()

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const orderStore = useOrderStore()

const currentModuleKind = ref('')
const menus = getNavMenus()

// 更新当前模块高亮
function updateCurrentModule() {
  for (const menu of menus) {
    if (!menu) continue
    if (menu.children && menu.children.length > 0) {
      const matchedChild = menu.children.find(child => child.path === route.fullPath)
      if (matchedChild) {
        currentModuleKind.value = menu.title
        localStorage.setItem('currentModuleKind', menu.title)
        return
      }
    }
  }
}

// 计算属性
const showBackButton = computed(() => {
  const routeName = route.name as string
  const menuPaths = [
    '/contract',
    '/estimate', 
    '/pending-estimate',
    '/material-control',
    '/material-pending-control',
    '/design-control',
    '/design-draft',
    '/design-pending-control',
    '/search',
    '/purchase',
    '/factory',
    '/inventory',
    '/finance-audit',
    '/group-audit',
    '/report',
    '/staff'
  ]
  for(let i = 0; i < menuPaths.length; i++){
    // console.log('route.path',route.path,menuPaths[i])
    if(route.path === menuPaths[i]){
      return false
    }
  }
  return true
  // return routeName !== 'home' && 
  //        routeName !== 'login' && 
  //        !menuPaths.includes(route.path)
})

// 页面标题
const pageTitle = computed(() => {
  // 首先尝试从路由的meta.title获取标题
  console.log('route', route)
  if (route.meta.title) {
    return route.meta.title as string
  }
  
  // 如果meta.title不存在，使用之前的逻辑作为后备
  switch (route.name) {
    case 'search':
      return '合同搜索'
    case 'ContractImages':
      return '合同图纸'
    case 'InventoryImages':
      return '其他图纸'
    case 'ProductList':
      return '产品列表'
    case 'ProductImages':
      return '产品图纸'
    case 'inventory':
      return '库存管理'
    case 'login':
      return '登录'
    case 'finance':
      return '财务审核'
    case 'group':
      return '集团审核'
    case 'factory':
      return '工厂分配'
    case 'staff':
      return '人员管理'
    case 'purchase':
      return '采购管理'
    case 'purchaseDetail':
      return '采购单详情'
    case 'notice':
      return '公告管理'
    default:
      return '江丰智造'
  }
})

// 显示订单信息
const showOrderInfo = computed(() => {
  return ['ContractImages', 'InventoryImages', 'ProductList', 'ProductImages'].includes(route.name as string)
})

// 订单信息
const productData = ref<any>(null)

// 获取订单数据
const fetchOrderData = async () => {
  if (!showOrderInfo.value) return
  
  const contractId = route.params.contractId
  if (!contractId) return

  try {
    await orderStore.fetchOrderData(Number(contractId))
  } catch (error) {
    console.error('获取订单数据失败:', error)
  }
}

// 获取产品数据
const fetchProductData = async () => {
  if (route.name !== 'ProductImages') return
  
  const productId = route.params.productId
  if (!productId) return
  console.log('获取产品数据')
  try {
    const response = await orderApi.getItemDetail(Number(productId))
    if (response.code === 0 && response.data) {
      productData.value = response.data
      console.log('产品数据:', productData.value)  // 添加日志
    }
  } catch (error) {
    console.error('获取产品数据失败:', error)
  }
}

// 监听路由变化
// watch(() => route.params.contractId, fetchOrderData, { immediate: true })
watch(() => route.params.productId, fetchProductData, { immediate: true })

// 订单信息显示
const orderInfo = computed(() => {
  if (!showOrderInfo.value) return ''

  switch (route.name) {
    case 'ContractImages':
    case 'InventoryImages':
    case 'ProductList':
      return orderStore.orderData?.so || ''
    case 'ProductImages':
      if (!productData.value) return ''
      const no = productData.value.no || ''
      const batch = productData.value.batch || ''
      return [no, batch].filter(Boolean).join(' · ')
    default:
      return ''
  }
})

// 初始化用户信息
onMounted(() => {
  if (localStorage.getItem('currentModuleKind') !== null && localStorage.getItem('currentModuleKind') !== undefined && localStorage.getItem('currentModuleKind') !== '') {
    currentModuleKind.value = localStorage.getItem('currentModuleKind') || ''
  }
  const userInfoStr = localStorage.getItem('userInfo')
  if (userInfoStr) {
    try {
      const userInfo = JSON.parse(userInfoStr)
      console.log('用户初始化:', {
        已登录: true,
        权限列表: userInfo.auths?.split(',') || []
      })
      userStore.setUserInfo(userInfo)
    } catch (e) {
      console.error('解析用户信息失败')
    }
  }
  updateCurrentModule()
})

// 监听路由变化，更新菜单高亮
watch(
  () => route.fullPath,
  () => {
    updateCurrentModule()
  }
)

// 方法
const handleBack = () => {
  if (props.onBack) {
    props.onBack()
  } else {
    router.back()
  }
}

const handleLogout = () => {
  userStore.clearUserInfo()
  sessionStorage.removeItem('searchCache')  // 清除搜索缓存
  sessionStorage.removeItem('currentProductPage')
  sessionStorage.removeItem('currentMaterialPage')
  sessionStorage.removeItem('currentProductScrollTop')
  sessionStorage.removeItem('currentMaterialScrollTop')
  // clearVersionCache()
  router.push('/login')
}

// 替换 onBeforeRouteLeave，使用 watch 来监听路由变化
watch(
  () => route.name,
  (newRouteName, oldRouteName) => {
    if (oldRouteName && ['ContractImages', 'InventoryImages', 'ProductList', 'ProductImages'].includes(oldRouteName as string) &&
        newRouteName && !['ContractImages', 'InventoryImages', 'ProductList', 'ProductImages'].includes(newRouteName as string)) {
      orderStore.clearOrderData()
    }
  }
)

/** 子菜单 path 可含 query（如集团生产进度 ?factory=1）；与同路径无生管入口区分高亮 */
function navSubItemIsActive(menuPath: string) {
  if (!menuPath.includes('?')) {
    if (menuPath === '/factoryManufactureProgress') {
      return route.path === '/factoryManufactureProgress' && String(route.query.factory ?? '') !== '1'
    }
    return route.path === menuPath
  }
  const [pathname, search] = menuPath.split('?')
  if (route.path !== pathname) return false
  const params = new URLSearchParams(search)
  for (const [key, value] of params.entries()) {
    const qv = route.query[key]
    const actual = Array.isArray(qv) ? qv[0] : qv
    if (String(actual ?? '') !== value) return false
  }
  return true
}

// 模块列表

console.log('获取到的菜单列表:', menus)

const moduleList = computed(() => {
  return [
    {
      title: '我的-业务员列表',
      parentTitle: '业务',
      icon: 'mdi-account',
      path: '/contract'
    },
    {
      title: '我的-估价员列表', 
      parentTitle: '成本',
      icon: 'mdi-account',
      path: '/estimate'
    },
    {
      title: '估价员列表',
      parentTitle: '成本',
      icon: 'mdi-account',
      path: '/pending-estimate'
    },
    {
      title: '我的-设计列表',
      parentTitle: '设计',
      icon: 'mdi-account',
      path: '/design-control'
    },
    {
      title: '我的-设计列表',
      parentTitle: '设计',
      icon: 'mdi-account',
      path: '/design-draft'
    },
    {
      title: '设计列表',
      parentTitle: '设计',
      icon: 'mdi-account',
      path: '/design-pending-control'
    },
    {
      title: '图纸查询',
      parentTitle: '设计',
      icon: 'mdi-account',
      path: '/search'
    },
    {
      title: '我的-物控列表', 
      parentTitle: '物控',
      icon: 'mdi-account',
      path: '/material-control'
    },
    {
      title: '物控列表',
      parentTitle: '物控',
      icon: 'mdi-account',
      path: '/material-pending-control'
    },
    {
      title: '我的-财务列表',
      parentTitle: '财务',
      icon: 'mdi-account',
      path: '/finance-audit'
    },
    {
      title: '我的-集团列表', 
      parentTitle: '集团',
      icon: 'mdi-account',
      path: '/group-audit'
    },
    {
      title: '工厂分配',
      parentTitle: '生管',
      icon: 'mdi-factory',
      path: '/factory',
    },
    {
      title: '库存管理',
      parentTitle: '生管',
      icon: 'mdi-package-variant',
      path: '/inventory',
    },
    {
      title: '采购管理',
      parentTitle: '采购',
      icon: 'mdi-cart',
      path: '/purchase',
    },
    {
      title: '我的-生产列表',
      parentTitle: '生管',
      icon: 'mdi-account',
      path: '/production'
    },
    {
      title: '生产列表',
      parentTitle: '工厂',
      icon: 'mdi-account',
      path: '/factoryManufacture'
    },
  ]
})

// 当前选中的模块
const currentModule = computed(() => {
  const currentRoute = route.path
  // const currentMenu = moduleList.value.find(menu => currentRoute.startsWith(menu.path))
  // console.log('当前菜单路由:', route.path,currentMenu,currentMenu?.parentTitle,'当前浏览器地址',currentRoute)
  // // 获取前一个路由
  // const previousRoute = route.matched[route.matched.length - 2]
  // console.log('前一个路由:', previousRoute,route.matched,router)
  // const parentTitle = sessionStorage.getItem('parentTitle')
  // var returnTitle = ''
  // moduleList.value.forEach(menu => {
  //   if(route.meta.parentTitle && route.meta.parentTitle === menu.parentTitle){
  //     sessionStorage.setItem('parentTitle', menu.parentTitle)
  //     returnTitle = route.meta.parentTitle
  //   }else{
  //     returnTitle = parentTitle
  //   }
  // })
  // console.log('当前模块点亮:', returnTitle)
  // console.log('当前模块:', route.meta.parentTitle)
  // console.log('菜单栏的:', moduleList.value)
  // return returnTitle
  // return currentMenu?.parentTitle || '图纸查询'
  return '图纸查询'
})

// 处理模块切换
const handleModuleChange = (item: { title: string; path: string }) => {
  router.push(item.path)
}

const handleChange = (item: { title: string; path: string }) => {
  currentModuleKind.value = item.title
  localStorage.setItem('currentModuleKind', item.title)
  console.log('处理模块切换', item, sessionStorage)
  sessionStorage.removeItem('title')
  sessionStorage.removeItem('currentProductPage')
  sessionStorage.removeItem('currentMaterialPage')
  sessionStorage.removeItem('currentProductScrollTop')
  sessionStorage.removeItem('currentMaterialScrollTop')
}
</script>

<style scoped>
.v-app-bar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.cursor-pointer {
  cursor: pointer;
}

.v-list-item {
  min-height: 40px;
}

.v-list-item__prepend > .v-icon {
  margin-inline-end: 8px;
}

.text-subtitle-2 {
  opacity: 0.8;
  font-size: 0.875rem;
}

.v-app-bar-title {
  color: white;
  font-size: 1.2rem;
  font-weight: 500;
}

.user-info {
  color: white;
  display: flex;
  align-items: center;
}

.nickname {
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
}

.dept-job {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.8rem;
}

.logout-btn {
  color: white !important;
  opacity: 0.8;
}

.logout-btn:hover {
  opacity: 1;
}

.module-btn {
  color: rgba(255, 255, 255, 0.7) !important;
  font-size: 0.95rem;
  font-weight: 500;
  /* margin-right: 16px; */
  height: 64px;
  border-radius: 0;
  position: relative;
}

.active-text{
  border-bottom: 3px solid #D2475D;
  display: inline-block;
  border-radius: 1px;
  width: 20px;
  position: absolute;
  bottom: 0px;
  left: 23px;
}

.module-btn:last-child {
  margin-right: 0;
}

.module-btn.active {
  color: white !important;
  border-bottom: 2px solid white;
}

.module-btn:hover {
  color: white !important;
}

.menu-list {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.menu-list :deep(.v-list-item) {
  color: rgba(255, 255, 255, 0.7) !important;
  min-height: 40px;
}

.menu-list :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.menu-list :deep(.v-list-item.active) {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
}

.menu-list :deep(.v-list-item-title) {
  font-size: 14px;
  text-align: center;
  display: flex;
  /* align-items: center;
  justify-content: center; */
}

.status-text{
  font-size: 0.7rem;
  height: 20px;
  box-sizing: border-box;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.redStatus{
  background-color: #453237 !important;
  color: rgb(var(--v-theme-error)) !important;
  border: 1px solid rgb(var(--v-theme-error)) !important;
  margin-right: 6px;
}
.yellowStatus{
  background: #453F2E;
  color: #EAB20B;
  border: 1px solid #EAB20B;
  margin-right: 6px;
}
.blueStatus{
  background-color: #323D4C !important;
  color: #6DA6E6 !important;
  border: 1px solid #6DA6E6;
  margin-right: 6px;
}
.greenStatus{
  background-color: #3B4D3E !important;
  color: #66BB6A !important;
  border: 1px solid #66BB6A;
  margin-right: 6px;
}
</style>
